import { startGame } from "outpost";
import { RootComponent } from "./root-component.ts";

async function main() {
    startGame(new RootComponent());
}

main();
